// Estimate the number of syllables in an English word. Same heuristic used by
// the Syllable Counter: count vowel groups, handle silent -e / -ed / -es and
// consonant+le endings, with a small dictionary of common irregulars.
const SYLLABLE_OVERRIDES = {
  poem: 2, poems: 2, poet: 2, poets: 2, lion: 2, lions: 2, being: 2,
  science: 2, sciences: 2, quiet: 2, quietly: 3, giant: 2, giants: 2,
  idea: 3, ideas: 3, area: 3, areas: 3, create: 2, creates: 2, created: 3,
  creating: 3, creative: 3, rhythm: 2, rhythms: 2, fluid: 2, fluids: 2,
  ruin: 2, ruined: 2, cruel: 1, diary: 3, dial: 2, trial: 2, prior: 2,
  riot: 2, diet: 2, real: 1, really: 2, interesting: 4, comfortable: 4,
  vegetable: 4, temperature: 4, squirrel: 2, choir: 1, prayer: 1, layer: 2,
  evening: 3, business: 2, everything: 3, hour: 1, hours: 1, our: 1,
  ours: 1, fire: 1, fires: 1, wire: 1, hire: 1, tire: 1,
};

export function countSyllables(word) {
  word = word.toLowerCase().replace(/[^a-z]/g, '');
  if (!word) return 0;
  if (SYLLABLE_OVERRIDES[word] != null) return SYLLABLE_OVERRIDES[word];
  if (word.length <= 3) return 1;
  const w = word.replace(/([^laeiouy])(?:es|ed)$/, '$1').replace(/e$/, '');
  let count = (w.match(/[aeiouy]+/g) || []).length;
  if (/[^aeiouy](?:le|les)$/.test(word)) count += 1;
  return Math.max(1, count);
}
